/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, SCS) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 */

	'use strict';
	/*globals Tc */

	/**
	 * Captcha module implementation.
	 *
	 * @author Dimitri Sebeschuk
	 * @namespace Tc.Module
	 * @class Captcha
	 * @extends Tc.Module
	 */
	Tc.Module.Captcha = Tc.Module.extend({


		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			SCS.captcha = SCS.captcha || {};

			if (!SCS.captcha.captchaHandler || typeof SCS.captcha.captchaHandler !== 'object') {
				SCS.captcha.captchaHandler = [];
			}

			SCS.captcha.captchaHandler.push([this, this.createCaptcha]);

			callback();
		},


		createCaptcha: function () {
			var mod = this,
				sitekey = mod.$ctx.data('sitekey'),
				theme = mod.$ctx.data('theme'),
				id = 'captchaContainer_' + mod.$ctx.data('uid');

			if (typeof grecaptcha === 'undefined') {
				//Show Exception
				debug.log('Tc.Module.Captcha -> createCaptcha: grecaptcha is not exists!');
				return;
			}

			grecaptcha.render(id, {
				'sitekey': sitekey,
				'theme': theme
			});

		}


	});

}(Tc.$, window.SCS));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.Captcha.js
// module id = 270
// module chunks = 0